"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _buttonControlSelector = _interopRequireDefault(require("../button-control-selector"));

var TopicSelector = function TopicSelector(_ref) {
  var showEvent = _ref.showEvent,
      inGroup = _ref.inGroup,
      noWrap = _ref.noWrap,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size;
  var urlSuffix = inGroup ? "group=".concat(inGroup) : '';

  var getSelectorItems = function getSelectorItems() {
    var contentTypes = [{
      isPrincipal: true,
      title: 'New article',
      href: "/content/new/article?".concat(urlSuffix)
    }, {
      title: 'New conversation',
      href: "/content/new/conversation?".concat(urlSuffix)
    }, {
      title: 'New question',
      href: "/content/new/question?".concat(urlSuffix)
    }];

    if (showEvent) {
      contentTypes.push({
        title: 'New event',
        href: '/content/new/event'
      });
    }

    return contentTypes;
  };

  if (noWrap) {
    return (0, _preact.h)(_buttonControlSelector.default, {
      size: size,
      variant: variant,
      items: getSelectorItems()
    });
  }

  return (0, _preact.h)("div", null, (0, _preact.h)(_buttonControlSelector.default, {
    size: size,
    variant: variant,
    items: getSelectorItems()
  }));
};

var _default = TopicSelector;
exports.default = _default;